import type { AccessPair } from '@/shared/lib'

/** `/v1/carts/**` — ресурс менеджера; модификатора не принимает, клиенту `403`. */
export const MANAGER_CARTS_ACCESS: AccessPair = { own: 'manager.cart.manage' }

/** Оформление и дозаказ: `POST /v1/carts/{id}/checkout`, `/append/{invoiceNo}`. */
export const MANAGER_CART_ORDER_PERMISSION = 'manager.order.create' as const
